export const enum RawMaterialStatusEnum {
    Active = 0,
    Disabled = 1,
}
